import React from 'react';
import { motion } from 'framer-motion';

export default function KompaLogo({ size = 'md' }) {
  const sizes = {
    sm: 'h-10 md:h-12',
    md: 'h-12 md:h-16',
    lg: 'h-16 md:h-20',
  };

  return (
    <motion.div
      className="flex items-center justify-center select-none"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: 'spring', stiffness: 300, damping: 25 }}
      data-testid="kompa-logo"
    >
      <img
        src="/kompa-logo.png"
        alt="KOMPA"
        translate="no"
        className={`${sizes[size]} w-auto object-contain notranslate`}
        style={{ mixBlendMode: 'multiply' }}
        draggable={false}
      />
    </motion.div>
  );
}
